import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";
import {rxUpdatePortfolioTransactions} from "./portfolioSlice";

const quotesAdapter = createEntityAdapter({
  selectId: q => q.symbol
});

const initialState = {
  quotes: quotesAdapter.getInitialState(),

  details: {
    quote: null,
    loading: true,
    error: null
  }
};

export const quotesSlice = createSlice({
  name: "quotes",
  initialState,
  reducers: {
    updateQuotes: (state, action) => {
      quotesAdapter.setMany(state.quotes, action.payload.uquotes || []);
      quotesAdapter.removeMany(state.quotes, action.payload.dquotes || []);
    },

    setQuoteDetails: (state, action) => {
      state.details.quote = action.payload.quote;
      state.details.loading = action.payload.loading;
      state.details.error = action.payload.error;

      if (action.payload.quote && quotesAdapter.getSelectors().selectById(state.quotes, action.payload.quote.symbol)) {
        quotesAdapter.setOne(state.quotes, action.payload.quote);
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      quotesAdapter.setMany(state.quotes, action.payload.quotes);
    });

    builder.addCase(rxUpdatePortfolioTransactions, (state, action) => {
      quotesAdapter.setMany(state.quotes, action.payload.uquotes || []);
      quotesAdapter.removeMany(state.quotes, action.payload.dquotes || []);
    });
  }
});

export const {
  updateQuotes: rxUpdateQuotes,
  setQuoteDetails: rxSetQuoteDetails
} = quotesSlice.actions;

export const {selectAll: selectAllQuotes} = quotesAdapter.getSelectors(state => state.quotes.quotes);

export const quoteDetailsSelector = state => state.quotes.details;

export default quotesSlice.reducer;
